function HomePage() {
    return (
    <header><div>
      
    </div>
    </header>)
}

export default HomePage;